import "./src/global.css";
import { registerRootComponent } from "expo";
import App from "./src/App";

// Register the main App component as the root of the application
registerRootComponent(App);
